import React from "react";
import ForgotPassword from "../../../components/auth/forgotpass/ForgotPassword";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
